/*=========================================================================================
  File Name: moduleDataList.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './modulePropertyTypeState.js'
import mutations from './modulePropertyTypeMutations.js'
import actions from './modulePropertyTypeActions.js'
import getters from './modulePropertyTypeGetters.js'

export default {
	isRegistered: false,
	namespaced: true,
	state: state,
	mutations: mutations,
	actions: actions,
	getters: getters
}

